module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2491"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2491"
    },
    "bundlingPackage": "marketplace-storefront-public-ui",
    "bundlingPackageVersion": "static-1.13560",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};